export default "__VITE_ASSET__BTXfl0jn__"